<div id="drupal-cms-client">
  <router-outlet></router-outlet>
</div>
